var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { WidgetTopic } from "@/utils/types/widgets";
import { useEffect, createElement, forwardRef, useRef, useState, useMemo, memo, } from "react";
import { useEvents } from "@/hooks/events";
import { Slot } from "@/utils/types/layout";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useLogger } from "@/utils/loggerService";
import { useLayout } from "@/hooks/layout";
import "./default";
import "./selector";
import "./weather";
import "./list";
import "./historique";
import "./image";
import "./module";
import "./error";
import "./filters";
import "./chart";
import "./create";
import "./fields";
import "./alerts";
import "./module/massupdate";
import "./module/dashboard";
import "./module/admin";
import "./module/home";
import "./module/admin";
import "./favorite";
import "./popup/widgetSelectorSubpanel";
import "./notes";
import "./chatIA";
import { useAppSelector } from "@/hooks/store";
/**
 * Composant afficheur de widgets
 * Les widgets sont sélectionnés depuis le dictionnaire central
 */
var WidgetDisplay = forwardRef(function (_a, ref) {
    var widget = _a.widget, canClose = _a.canClose;
    var events = useEvents().eventBus;
    var removeWidget = useLayout().removeWidget;
    var logger = useLogger().logger;
    var widgetRef = useRef(null);
    var _b = useState({ width: 0, height: 0 }), size = _b[0], setSize = _b[1];
    useEffect(function () {
        var el = widgetRef.current;
        if (!el)
            return;
        var observer = new ResizeObserver(function (_a) {
            var entry = _a[0];
            var _b = entry.contentRect, width = _b.width, height = _b.height;
            setSize({ width: width, height: height });
        });
        observer.observe(el);
        return function () { return observer.disconnect(); };
    }, []);
    // Mode édition de layouts
    var editingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    useEffect(function () {
        events.publish("".concat(WidgetTopic.WIDGET_CREATED), {
            widget: widget,
            events: events,
        });
        events.publish("".concat(WidgetTopic.WIDGET_CREATED, "/").concat(widget.id), {
            widget: widget,
            events: events,
        });
        var closeHandler = function (_a) {
            var widget = _a.widget, reason = _a.reason;
            if (canClose && !canClose(widget, events)) {
                return;
            }
            logger.debug("[WIDGET_DIPLAY] - Envoi WIDGET_CLOSE", widget);
            events.trigger(WidgetTopic.WIDGET_CLOSE, { widget: widget, reason: reason });
            events.trigger("".concat(WidgetTopic.WIDGET_CLOSE, "/").concat(widget.id), {
                widget: widget,
                reason: reason,
            });
            logger.debug("[WIDGET_DIPLAY] - Fermeture du widget", widget);
            removeWidget(widget);
        };
        // Listen for close
        var subscriptionId = events.on("".concat(WidgetTopic.WIDGET_REQUEST_CLOSE, "/").concat(widget.id), closeHandler);
        return function () {
            events.off(subscriptionId);
        };
    }, [widget]);
    var hasDefault = useAppSelector(function (state) { return state.theme; }).hasDefault;
    // Définition du widget
    //const widgetDefinition = widgetsDictionary.get(widget.type);
    var widgetDefinition = useMemo(function () { return widgetsDictionary.get(widget.type); }, [widget.type]);
    var inEditMode = editingLayout &&
        ((widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.editable) === undefined || (widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.editable));
    if (!widgetDefinition && process.env.NODE_ENV !== "production") {
        logger.warn("[WIDGET_DISPLAY] - Le composant ".concat(widget.type, " n'existe pas"));
        return _jsx(_Fragment, { children: "".concat(widget.type) });
    }
    else if (!widgetDefinition) {
        logger.debug("[WIDGET_DISPLAY] - Le composant ".concat(widget.type, " n'existe pas"));
        return _jsx(_Fragment, {});
    }
    var smallSlot = [
        Slot.HEADER_START,
        Slot.HEADER_CENTER,
        Slot.HEADER_END,
        Slot.FOOTER_START,
        Slot.FOOTER_CENTER,
        Slot.FOOTER_END,
        Slot.MENU_NORTH,
    ];
    var isHfull = widget.type === "widget/chatIA";
    return (_jsx("div", __assign({ className: "relative flex flex-col ".concat(isHfull && "h-full") }, { children: _jsx("div", __assign({ className: "".concat(widget.slot !== Slot.MAIN &&
                inEditMode &&
                widget.slot &&
                !smallSlot.includes(widget.slot)
                ? "blur-md"
                : "", "  transition-all h-full  dark:text-[rgb(var(--color-gray-200))]") }, { children: inEditMode && (widget === null || widget === void 0 ? void 0 : widget.slot) && !smallSlot.includes(widget.slot) ? (_jsx("div", { className: " ".concat(widget.slot === Slot.MAIN
                    ? "w-full h-full min-h-[50px] md:min-h-[380px] max-h-full  flex items-center justify-center backdrop-blur-sm bg-black/35 pointer-events-none overflow-y-hidden"
                    : "w-full  min-w-[12.5rem]  overflow-y-hidden items-center") })) : (createElement(widgetDefinition.display, {
                widget: widget,
                events: events,
            })) })) })));
});
export default memo(WidgetDisplay);
